import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { AdjustmentNote } from "../state/types"

export const useAdjustmentNoteActions = () => {
    const saveActions = useSaveActions()

    const saveAdjustmentNote = (adjustmentNote: AdjustmentNote) => {
        const { save } = saveActions()
        return save(TableName.ADJUSTMENT_NOTES, adjustmentNote) as Promise<AdjustmentNote>
    }

    const removeAdjustmentNote = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.ADJUSTMENT_NOTES, id)
    }

    return {
        saveAdjustmentNote,
        removeAdjustmentNote
    }
}
